export default __webpack_public_path__ + "static/media/IMAGE.fe15af57.png";